import { Components, Theme } from "@mui/material";

export const MuiCardContent: Components<Theme>["MuiCardContent"] = {
  styleOverrides: {
    root: {
      "&:last-child": {
        paddingBottom: 15,
      },
    },
  },
};
